import React from 'react';
import { WizardItem } from '../../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../../Enums/WizardItemType.enum';
import FormCondition from '../../../../BaseModule/Components/Form/Components/FormCondition/FormCondition';
import WizardChildren from '../../WizardChildren';

interface Props {
	item: Extract<WizardItem, { type: WizardItemType.CONDITION }>;
	onSubmit: (values: object) => void;
}

const WizardCondition: React.FC<Props> = ({ item, onSubmit }) => {
	return (
		<FormCondition
			controlName={item.value}
			equal={item.settings.equal}
			resetValuesOnConditionMet={item.settings.resetValuesOnConditionMet}
		>
			{item.children.map(child => (
				<WizardChildren key={child.id} item={child} onSubmit={onSubmit} />
			))}
		</FormCondition>
	);
};

export default WizardCondition;
